import React from 'react';
import { IconIdNotFound } from '../../../../components/buttons/IconButtons';
import { useTranslation } from 'react-i18next';
import ContainerValidation from "./Components/ContainerValidation";
import HeaderValidation from "./Components/HeaderValidation";
import BodyValidation from "./Components/BodyValidation";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const InvitationNotFound = ({ trans }) => {

    const { t } = useTranslation();

    return (
        <ContainerValidation>
            <HeaderValidation showBtnBack={false}/>
            <BodyValidation
                showBtnNext={false}
                showBtnPrev={false}
                showLogoFooter={true}
            >
                <div className="row">
                    <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                        <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-center">{t(trans)}</p>
                    </div>
                </div>

                <div className="d-flex justify-content-center align-items-center">
                    <div className="icon-identity-validation-container">
                        <IconIdNotFound className="w-100 h-100" />
                    </div>
                </div>
            </BodyValidation>
        </ContainerValidation>
    )
}
export default InvitationNotFound
